import StorageNearYou from 'assets/images/psp/storage-near-you/storage-near-you.svg';

export const StorageNearYouData = (type = '', state = '', city = '') => ({
	title:
		type == 'Electricity'
			? `Self Storage with ${type}: Browse More Locations`
			: type == 'Facility'
				? `Find Storage Near You`
				: `${type} Self Storage: Browse More Locations`,
	image: StorageNearYou,
	nearByDetectedCities: {
		title:
			type == 'Electricity'
				? `More Self Storage with ${type} in Nearby Cities`
				: type == 'Facility'
					? city && state
						? `Self Storage in Cities Near ${city}, ${state}`
						: `Self Storage in Nearby Cities`
					: `More ${type} Self Storage in Nearby Cities`,
		cities: [],
	},
	citiesByState: {
		title:
			type == 'Electricity'
				? `More Self Storage with ${type} Across ${state}`
				: type == 'Facility'
					? state
						? `Self Storage in ${state}`
						: `Self Storage in Your Area`
					: `More ${type} Self Storage Across ${state}`,
		cities: [],
	},
	statesLink: {
		title:
			type == 'Electricity'
				? `More Self Storage with ${type} in Major Cities`
				: type == 'Facility'
					? `Self Storage in Other Popular Cities`
					: `More ${type} Self Storage in Major Cities`,
		cities: [
			{
				slug: '/self-storage/new-york/new-york/',
				name: 'New York, NY',
			},
			{
				slug: '/self-storage/california/los-angeles/',
				name: 'Los Angeles, CA',
			},
			{
				slug: '/self-storage/texas/houston/',
				name: 'Houston, TX',
			},
			{
				slug: '/self-storage/massachusetts/boston/',
				name: 'Boston, MA',
			},
			{
				slug: '/self-storage/texas/austin/',
				name: 'Austin, TX',
			},
			{
				slug: '/self-storage/nevada/las-vegas/',
				name: 'Las Vegas, NV',
			},
			{
				slug: '/self-storage/florida/miami/',
				name: 'Miami, FL',
			},
			{
				slug: '/self-storage/washington/seattle/',
				name: 'Seattle, WA',
			},
			{
				slug: '/self-storage/colorado/denver/',
				name: 'Denver, CO',
			},
			{
				slug: '/self-storage/georgia/atlanta/',
				name: 'Atlanta, GA',
			},
		],
	},
});
